import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Tabs, Form, Button, Input, message } from "antd";
import { common } from "../../utils";
const TabPane = Tabs.TabPane;
export class ForgetPwd extends Component {
  state = {
    codeTxt: "获取验证码",
    phone: "",
  }
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      values.TypeID = 1;
      if (!err) {
        this.props.actions.fetchEditStuPwd(values).then(res => {
          if (res.SuccessResponse) {
            message.success(res.Message);
          }
        })
      }
    });
  }
  getCode() {
    if (this.state.phone.trim() === "") {
      message.warn("手机号码不能为空");
      return;
    }
    if (common.checkPhone(this.state.phone)) {
      let seconds = 60;
      this.setState({
        codeTxt: "发送中..."
      })
      this.props.actions.fetchGetPhoneCodeByLogin({ Phone: this.state.phone }).then(res => {
        if (res.SuccessResponse) {
          message.success(res.Message);
          let timer = setInterval(() => {
            if (seconds > 0) {
              this.setState({
                codeTxt: `${seconds--}秒`
              })
            } else {
              clearInterval(timer);
              this.setState({
                codeTxt: "获取验证码",
              })
            }
          }, 1000)
        } else {
          this.setState({
            codeTxt: "获取验证码",
          })
        }
      })
    } else {
      message.warn("请输入正确的手机号")
    }
  }
  render() {
    const operations = <span className="goLogin" onClick={() => { this.props.history.push('/login') }}>返回登录 ></span>;
    const { getFieldDecorator } = this.props.form;
    const { codeTxt } = this.state;
    return (
      <div className="common-forget-pwd">
        <div className="forget-pwd-view">
          <img src={require("../../images/login_img.png")} alt="" />
          <Tabs defaultActiveKey="1" className="forget-pwd-tabs" tabBarExtraContent={operations}>
            <TabPane tab="找回密码" key="1">
              <Form onSubmit={this.handleSubmit} className="register-form">
                <Form.Item>
                  {getFieldDecorator('Phone', {
                    rules: [{ required: true, message: '请输入手机号' }, {
                      pattern: "^[1][3,4,5,6,7,8,9][0-9]{9}$", message: "请输入正确的手机号"
                    }],
                  })(
                    <Input
                      placeholder="手机号"
                      onChange={e => this.setState({
                        phone: e.target.value
                      })}
                      style={{ height: 40 }}
                    />,
                  )}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator('PhoneCode', {
                    rules: [{ required: true, message: '请输入验证码' }],
                  })(
                    <Input
                      placeholder="验证码"
                      style={{ height: 40 }}
                      suffix={
                        <p className="getCode" onClick={() => {
                          if (codeTxt === "获取验证码") {
                            this.getCode();
                          }
                        }}>{codeTxt}</p>
                      }
                    />,
                  )}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator('newPassword', {
                    rules: [{ required: true, message: '请输入新密码' }, {
                      min: 6, message: "字符长度不小于六位"
                    }, {
                      max: 23, message: "字符长度不超过十六位"
                    }, {
                      validator: (rule, value, cb) => {
                        let lvl = 0;
                        if (/[0-9]/.test(value)) {
                          lvl++;
                        }
                        if (/[a-zA-Z]/.test(value)) {
                          lvl++;
                        }
                        if (/[^0-9a-zA-Z_]/.test(value)) {
                          lvl++;
                        }
                        if (lvl >= 2) {
                          cb();
                        } else {
                          cb('新密码不符合提示要求')
                        }
                      }
                    }],
                  })(
                    <Input.Password
                      placeholder="新密码"
                      style={{ height: 40 }}
                    />,
                  )}
                  <p className="tip">密码长度6-23位，须包含数字、字母、符号至少2种或以上元素</p>
                </Form.Item>
                <Form.Item>

                  <Button type="theme" htmlType="submit" className="forget-pwd-form-button">
                    完成
              </Button>
                </Form.Item>
              </Form>
            </TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: 'normal_forget_pwd' })(ForgetPwd));



// WEBPACK FOOTER //
// ./src/features/common/ForgetPwd.js